import axios from "axios";
import store from "@/store";
import router from "../router";
import ElementUI from "element-ui";

/* 取消接口请求的操作器:请根据版本选择合适的操作器 */
class CancelControl {
  /* 构造函数 */
  constructor() {
    this.allCancelApi = {};
  }
  /* 此方法记录请求函数 calcelAPI:接口名称或者url */

  setAbortAPI(calcelAPI) {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    this.allCancelApi[calcelAPI] = source;
    return source.token;
  }
  /* 执行此方法取消请求 calcelAPI:接口名称或者url */

  abort(calcelAPI) {
    if (this.allCancelApi[calcelAPI]) {
      this.allCancelApi[calcelAPI].cancel("Cancel");
    }
  }
}
export const cancelControl = new CancelControl();

const utile = require("../utile.js");
// 创建axios实例
let instance = axios.create();
instance.interceptors.request.use((config) => {
  // 如果不是调用登录接口的话
  if (config.url.indexOf("user/login") < 0) {
    // token
    let token = window.localStorage.getItem("token");
    if (token == null || token == "") {
      router.push("/login");
    }
    // 添加header
    config.headers["token"] = token;
    config.headers["ngrok-skip-browser-warning"] = 69420;
  }
  if (config.multipleCancel) {
    // 如果设置了连续请求时取消之前的请求
    cancelControl.abort(config.url);
    config.cancelToken = cancelControl.setAbortAPI(
      config.url
    ); /* axios  v0.22.0以下版本  */
    // config.signal = cancelControl.setAbortAPI(url)  /* axios  v0.22.0以上版本 */
  }
  // 返回
  return config;
});
instance.interceptors.response.use(
  (response) => {
    if (response && response.data) {
      if (response.data.code == 70006 || response.data.code == 70004) {
        if (window.location.href.indexOf("user/login") < 0) {
        }
        localStorage.removeItem("token");
        router.push("/login");
      } else if (response.data.code == 500406) {
        if (window.location.href.indexOf("user/login") < 0) {
        }
        let token = window.localStorage.getItem("token");
        if (token != "" && token != null) {
          ElementUI.Message.warning(
            "当前账号目前在其它设备上登录，请注意账号安全！"
          );
        }
        localStorage.removeItem("token");
        router.push("/login");
      } else {
        return response;
      }
    } else {
      return response;
    }
  },
  function (error) {}
);
export default instance;
